import { SharedState } from '@trello/shared-state';

export const notificationsPaneState = new SharedState({
  loading: 0,
  cancelLoading: false,
  moreToLoad: true,
  loadingUnread: 0,
  cancelLoadingUnread: false,
  moreUnreadToLoad: true,
  notificationGroupsStale: false,
});
